{
  "it": {
    "employee": {
      "actions": {
        "accessProjects": "Gestisci accesso ai progetti",
        "cancel": "Annulla",
        "changeProfilePicture": "Cambia immagine del profilo",
        "change_role": "Cambia ruolo in",
        "download": "Scarica",
        "new": "Membro del team",
        "profilePictureFormat": "Deve avere una dimensione minima di 300x300px",
        "save": "Salva",
        "searchEmployee": "Cerca membro del team",
        "sendinvitation": "Crea e invia invito",
        "submit": "Salva",
        "undoChanges": "Annulla"
      },
      "attributes": {
        "email_address": "Email",
        "email_notifications_interval": {
          "daily": "Una volta al giorno (verso mezzogiorno)",
          "hourly": "Ogni ora",
          "twice_daily": "Due volte al giorno (mattina/mezzogiorno)",
          "weekly": "Una volta a settimana (lunedì a mezzogiorno)"
        },
        "first_name": "Nome",
        "language": "Lingua",
        "last_name": "Cognome",
        "phone_landline": "Numero fisso",
        "phone_mobile": "Numero di cellulare",
        "profession": "Qualifica professionale",
        "role": "Diritti di accesso",
        "signature_html": "Firma della conversazione",
        "status": "Stato",
        "title": "Titolo"
      },
      "integrations": {
        "hide_details": "Nascondi dettagli",
        "last_synced_at": "Ultima sincronizzazione: {time}",
        "show_details": "Mostra dettagli"
      },
      "labels": {
        "all_projects": "Tutti i progetti",
        "confirmChangeRoleTitle": "Cambiare ruolo in {role}?",
        "confirmChangeRoleToMaintainer": "Nota: {name} perderà l'accesso a tutti i progetti e tutte le notifiche esistenti verranno rimosse. In seguito potrà riassegnare {name} ai progetti come Gestore.",
        "confirmChangeRoleToOwner": "{name} otterrà l'accesso a tutti i progetti e a tutti i contenuti della piattaforma.",
        "confirmPasswordReset": "È stata inviata un'email con un link per reimpostare la password; controlli la Sua casella di posta. Ci contatti se riscontra problemi.",
        "disabled": {
          "access": "Concederemo a tutti i dipendenti l'accesso alla piattaforma non appena l'ultima fattura scaduta sarà stata pagata.",
          "contact": "Ci contatti",
          "overdue": "Abbiamo notato che l'ultima fattura è scaduta da tempo. Abbiamo revocato l'accesso alla piattaforma per tutti i dipendenti. Partner e clienti potranno comunque accedere ai propri dati.",
          "title": "Il Suo account è stato disabilitato."
        },
        "display": "Visualizzazione",
        "filters": "Filtri",
        "generalNotifications": "Riceva notifiche su",
        "has_access_to": "Ha accesso a",
        "information": "Informazioni del profilo",
        "informationNotificationsEmail": "Riceva una panoramica via email, che include solo le notifiche che non ha ancora visto sulla piattaforma.",
        "informationNotificationsPlatform": "Riceva tutte le notifiche nella Sua panoramica personale in alto a destra dello schermo",
        "informationNotificationsTitle": "Decida quali notifiche desidera ricevere e in che modo",
        "its_you!": "È Lei.",
        "last_login": "Ultimo accesso",
        "maintainerAccess": "Richiede l'accesso per singolo progetto.",
        "name": "Nome",
        "onPlatform": "Sulla piattaforma",
        "ownerAccess": "Ha accesso a tutti i progetti e i contenuti sulla piattaforma {client_name}.",
        "password": "Password",
        "permissions": "Diritti di accesso per",
        "permissionsOwnerOnly": "Come Gestore di progetto non può eseguire questa azione. Chieda a un membro del team di {client_name} con ruolo Proprietario di farlo per Lei.",
        "projectMaintains": "{first_name} ha accesso ai seguenti progetti:",
        "projectMaintainsAdd": "Per concedere l'accesso, selezioni un progetto e aggiunga {first_name} come Gestore di progetto nella funzione Informazioni.",
        "projectMaintainsNone": "non ha accesso ad alcun progetto.",
        "projectNotifications": "Per il progetto",
        "search_by_name_or_email": "Cerca per nome o email",
        "show_signature": "Mostra firma",
        "signature_active": "Firma attiva",
        "signature_info": "Questa firma verrà aggiunta alle risposte inviate a clienti e partner.",
        "sorting": "Ordinamento",
        "viaEmail": "Via email"
      },
      "modals": {
        "maintainers_access": {
          "accessible": "Accessibile",
          "description": "Le modifiche vengono salvate automaticamente",
          "not_accessible": "Non accessibile",
          "title": "Aggiorna l'accessibilità del progetto per {first_name} {last_name}"
        }
      },
      "roles": {
        "maintainer": "Gestore",
        "owner": "Proprietario"
      },
      "toasts": {
        "create": "Membro del team creato",
        "update": "Membro del team aggiornato"
      },
      "validation": {
        "emailTaken": "L'indirizzo email è già stato utilizzato",
        "mustBeEmailAddress": "È richiesto un indirizzo email valido",
        "needFirstName": "Nome obbligatorio",
        "needLastName": "Cognome obbligatorio",
        "requireEmailAddress": "Email obbligatoria",
        "role": "Selezionare i diritti di accesso"
      }
    }
  }
}
